export default __webpack_public_path__ + "static/media/uploadData.f6d08a67.svg";